import React from "react";
import { FormControl, Select, MenuItem } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";

// These fields are not grid columns; MUI ignores them client-side and the backend orders by them.
const sortOptions = [
  { label: "Latest", value: "latest", sortModel: [{ field: "created_at", sort: "desc" }] },
  { label: "Ascending", value: "asc", sortModel: [{ field: "site_participant", sort: "asc" }] },
  { label: "Descending", value: "desc", sortModel: [{ field: "site_participant", sort: "desc" }] },
];

const getSelectedValue = (sort) => {
  // With no sort the backend already orders latest added first.
  if (!sort?.length) return "latest";

  const match = sortOptions.find(
    (option) =>
      option.sortModel[0].field === sort[0].field && option.sortModel[0].sort === sort[0].sort
  );
  return match ? match.value : "";
};

const CustomSortSelector = ({ patientTableConfigurations, onSortModelChange }) => {
  const handleSortChange = (event) => {
    const option = sortOptions.find((o) => o.value === event.target.value);
    onSortModelChange(option.sortModel);
  };

  return (
    <FormControl>
      <InputLabel id="patient-sort-select-label">Sort By</InputLabel>
      <Select
        labelId="patient-sort-select-label"
        style={{ height: "30px", minWidth: 130 }}
        value={getSelectedValue(patientTableConfigurations?.sort)}
        onChange={handleSortChange}
        label="Sort By"
        inputProps={{ "aria-label": "Sort By" }}
        data-testid="patient-sort-select"
      >
        {sortOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomSortSelector;
